// src/services/api/stockTransfer.js
import { apiClient } from './base';

/**
 * Get warehouses assigned to the current user (source options)
 */
export const getAccessibleWarehouses = async () => {
  const response = await apiClient.get('/stock-transfers/warehouses/accessible');
  return response.data;
};

/**
 * Get all warehouses of the business (destination options)
 */
export const getAllWarehouses = async () => {
  const response = await apiClient.get('/stock-transfers/warehouses/all');
  return response.data;
};

/**
 * Search products with stock in a warehouse
 * @param {Object} params - { warehouseId (required), search, page, limit }
 */
export const searchProductsForTransfer = async (params) => {
  const response = await apiClient.get('/stock-transfers/products/search', { params });
  return response.data;
};

export const getStockTransfers = async (params) => {
  const response = await apiClient.get('/stock-transfers', { params });
  return response.data;
};

export const getStockTransferById = async (transferId) => {
  const response = await apiClient.get(`/stock-transfers/${transferId}`);
  return response.data;
};

export const createStockTransfer = async (data) => {
  const response = await apiClient.post('/stock-transfers', data);
  return response.data;
};

export const updateStockTransfer = async (transferId, data) => {
  const response = await apiClient.put(`/stock-transfers/${transferId}`, data);
  return response.data;
};

export const deleteStockTransfer = async (transferId) => {
  const response = await apiClient.delete(`/stock-transfers/${transferId}`);
  return response.data;
};

/**
 * Complete transfer: deducts stock from source and adds to destination
 */
export const completeStockTransfer = async (transferId) => {
  const response = await apiClient.post(`/stock-transfers/${transferId}/complete`);
  return response.data;
};
